import { render } from "./HomeView.vue?vue&type=template&id=2e490a8e&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=2e490a8e&lang=scss&scoped=true"

import exportComponent from "D:\\nbjgjxh\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e490a8e"]])

export default __exports__